import { useEffect, useState } from 'react'

/** `value`'nun `delayMs` durağan kaldıktan sonraki hâli — yazarken istek patlamasını önler. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
